export const VIEW_TYPE_REMODELING = 'REMODELING';
export const VIEW_TYPE_MAIN = 'MAIN';
export const VIEW_TYPE_MALL = 'MALL';
export const VIEW_TYPE_HOMEIDEA = 'HOMEIDEA';

export const TYPE_VALUE_MOBILE = 'MOBILE';
export const TYPE_VALUE_PC = 'PC';

export const GNB_REMODELING_SECTION = 'GnbRemodelingSection';
export const GNB_REMODELING_SHOP = 'GnbRemodelingShop';
export const GNB_REMODELING_GOODS = 'GnbRemodelingGoods';
export const GNB_REMODELING_START = 'GnbRemodelingStart';
export const GNB_REMODELING_EVENT = 'GnbRemodelingEvent';
export const GNB_REMODELING_REHOUSE = 'GnbRemodelingRehouse';

export const GNB_MALL_CARD = 'card';
export const GNB_MALL_HOME = 'home';
export const GNB_MALL_SSO = 'sso';
export const GNB_MALL_COMPO = 'compo';
export const GNB_MALL_BEST = 'best';
export const SNB_MALL_BEST_WEEKRANK = 'weekRank';
export const SNB_MALL_BEST_HIGHEST = 'highest';
export const SNB_MALL_BEST_SHOPPING = 'shopping';
export const SNB_MALL_BEST_REVIEW = 'review';
export const GNB_MALL_EVENT = 'event';
export const SNB_MALL_EVENT_ALL = 'ALL';
export const SNB_MALL_EVENT_CS = 'CS';
export const SNB_MALL_EVENT_F = 'F';
export const SNB_MALL_EVENT_D = 'D';
export const SNB_MALL_EVENT_SV = 'SV';
export const GNB_MALL_OULET = 'oulet';
export const GNB_MALL_BRAND = 'brand';
export const SNB_MALL_BRAND_BRAND_PICK = 'brand_pick';
export const SNB_MALL_BRAND_F = 'F';
export const SNB_MALL_BRAND_ALL = 'all';
export const GNB_MALL_DEAL = 'deal';
export const SNB_MALL_DEAL_WEEKDAY = 'weekday';
export const SNB_MALL_DEAL_WEEKEND = 'weekend';
export const SNB_MALL_DEAL_SEASON = 'season';
export const SNB_MALL_DEAL_HA = 'ha';
export const SNB_MALL_DEAL_FREEPASS = 'freepass';
export const SNB_MALL_DEAL_RDO = 'rdo';

export const GNB_HOMEIDEA_RECOMMEND = 'recommend';
export const GNB_HOMEIDEA_APARTMENT = 'apartment';
export const GNB_HOMEIDEA_SPACEANDPHOTO = 'spaceandphoto';
export const GNB_HOMEIDEA_MAGAZINE = 'magazine';
export const GNB_HOMEIDEA_CONSTCASE = 'constcase';

export const INFORMED_GOODS_LARGE_CATEGORY = 'largeCategoryTemplateNo';
export const INFORMED_GOODS_MIDDLE_CATEGORY = 'middleCategoryTemplateNo';
export const INFORMED_GOODS_SMALL_CATEGORY = 'smallCategoryTemplateNo';
export const INFORMED_SHOP_DETAIL_INTERIOR_AGENT =
  'shopIntAgntDetailTemplateNo';
export const INFORMED_MAIN_MENU = 'mainMenuTemplateNo';
export const INFORMED_MAIN_MENU_CODE = 'mainMenuTemplateCode';

export const NO_SWIPE_AREA = 'no-swiping';
